<div class="order-info__tab">
  @if (propertyUnitLoading) {
    <div class="loading-container">
      <app-spinner></app-spinner>
    </div>
  } @else if (propertyUnit) {
    <div class="basic-data">
      <h4>اسم الوحدة</h4>
      <p>
        {{ propertyUnit?.custom_name || "-" }}
      </p>
    </div>
    <div class="basic-data">
      <h4>علاقة طالب الخدمة</h4>
      <p>
        {{ formatPropertyRelations() }}
      </p>
    </div>
    <div class="basic-data">
      <h4>مساحة الوحدة الأساسية</h4>
      <p>
        {{
          propertyUnit?.surfaces_space
            ? propertyUnit.surfaces_space + " م²"
            : "-"
        }}
      </p>
    </div>
    <div class="basic-data">
      <h4>المنطقة</h4>
      <p>
        {{ propertyUnit?.address_area?.name || "-" }}
      </p>
    </div>
    <div class="basic-data">
      <h4>مدينة العقار</h4>
      <p>
        {{ propertyUnit?.address_city?.name || "-" }}
      </p>
    </div>
    <div class="basic-data">
      <h4>الحى</h4>
      <p>
        {{ propertyUnit?.district?.name || "-" }}
      </p>
    </div>
    <div class="basic-data">
      <h4>اسم الشارع</h4>
      <p>
        {{ propertyUnit?.address_street || "-" }}
      </p>
      <p
        class="address-map"
        type="button"
        (click)="copyAddress()"
        aria-label="نسخ العنوان على الخريطة"
      >
        نسخ العنوان على الخريطة
      </p>
    </div>

    <div class="section-action">
      <a
        class="btn btn-add"
        target="_blank"
        [routerLink]="['/pages/property-units', propertyUnit?.id]"
      >
        <span>تفاصيل الوحدة</span>
      </a>
    </div>
  } @else {
    <p class="no-data">لا توجد بيانات لعرضها</p>
  }
</div>
